// src/components/DownloadModal.jsx
// 데스크톱 진입 시: Android 내부 테스트 / iOS App Store(홈)로 연결하는 QR 제공
import React from "react";
import { buildQrUrls, CONFIG } from "../../utils/deeplink";
import styles from "./DownloadModal.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function DownloadModal({ open, onClose }) {
  if (!open) return null;

  const { iosQr, androidQr } = buildQrUrls();
  // const iosLink = CONFIG.ios.appStoreUrl;
  // const playLink = CONFIG.android.playStoreUrl;

  return (
    <div className={cx("backdrop")} onClick={onClose}>
      <div className={cx("modal")} onClick={(e) => e.stopPropagation()}>
        <div className={cx("grid")}>
          <div className={cx("card")}>
            <h4>IOS</h4>
            <img src={iosQr} alt="App Store QR" width={180} height={180} />
          </div>

          <div className={cx("card")}>
            <h4>Android </h4>
            <img
              src={androidQr}
              alt="Google Play Internal Test QR"
              width={180}
              height={180}
            />
          </div>
        </div>

        <button className={cx("close-btn")} onClick={onClose}>
          닫기
        </button>
      </div>
    </div>
  );
}
